module.exports = __webpack_public_path__ + "media/components/resources/show/resource-show-native-ad/img/mailchimp-54e4b5139dbe25777e242a92d4f1a4f9.png";